import { render } from "./AppNavigationItem.vue?vue&type=template&id=d1d292fc&scoped=true"
import script from "./AppNavigationItem.vue?vue&type=script&lang=js"
export * from "./AppNavigationItem.vue?vue&type=script&lang=js"

import "./AppNavigationItem.vue?vue&type=style&index=0&id=d1d292fc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1d292fc"]])

export default __exports__